import { Trans } from "@lingui/macro";
import { Box, Link } from "@mui/material";
import { ThemedText } from "src/theme/text";
import styled from "styled-components/macro";
import { ReactComponent as VYRO } from "src/assets/images/tokens/VYRO.svg";
import { ReactComponent as EsVYRO } from "src/assets/images/tokens/esVYRO.svg";
import { ReactComponent as USDT } from "src/assets/images/tokens/USDT.svg";
import { formatAmount2 } from "src/helpers/Helpers";
import { useGetVyroPrice } from "src/hooks/get_price_vyro";
import { useSelector } from "react-redux";
import { BuyBtn } from "src/components/Button/BuyBtn";
import { ClaimBtn } from "src/components/Button/ClaimBtn";
import {
  useBalance_VYRO,
  useBalance_esVYRO,
  useBalance_usdc,
  useESTokenStakedV2Balance,
} from "src/hooks/useQueryEarn";
import { NavLink } from "react-router-dom";
import { BUY_VYRO_URL } from "src/constants/misc";
import { useWeb3Context } from "src/hooks";

export const AssetBox = styled(Box)`
  margin-top: 32px;
  .assetHeader,
  .assetItem {
    .td {
      margin-left: 12px;
      :last-child {
        margin-right: 12px;
      }
    }
  }
  .assetHeader,
  .assetHeader-m {
    height: 40px;
  }
  .assetItem {
    padding: 18px 0;
  }
  /* .assetHeader,
  .assetHeader-m, */
  .assetItem,
  .assetItem-m {
    border-top: 1px solid ${({ theme }) => theme.bg4};
  }
`;

export default function AssetList() {
  const VYROPrice = useGetVyroPrice();
  const usdcBalance = useBalance_usdc();
  const VYROBalance = useBalance_VYRO();
  const VYROStaked = 0;
  const esVYROBalance = useBalance_esVYRO();
  const esVYROStaked = useESTokenStakedV2Balance();
  const tokensArr = useSelector((state: any) => {
    return state?.app?.tokensArr || [];
  });
  const { chainID } = useWeb3Context();
  const handlerBuy = () => {
    chainID == 421614 && window.open(BUY_VYRO_URL[chainID]);
  };
  return (
    <AssetBox className="assetList">
      <Box display="flex" alignItems="center" className="assetHeader">
        <ThemedText.Text4Bold className="flex-1 td">
          <Trans>Asset</Trans>
        </ThemedText.Text4Bold>
        <Box width="200px" className="text-right td">
          <ThemedText.Text4Bold>
            <Trans>Total</Trans>
          </ThemedText.Text4Bold>
        </Box>
        <Box width="200px" className="text-right td">
          <ThemedText.Text4Bold>
            <Trans>Wallet</Trans>
          </ThemedText.Text4Bold>
        </Box>
        <Box width="200px" className="text-right td">
          <ThemedText.Text4Bold>
            <Trans>Staked</Trans>
          </ThemedText.Text4Bold>
        </Box>
        <div className="flex-1 td"></div>
      </Box>
      <Box display="flex" alignItems="center" className="assetItem">
        <Box display="flex" alignItems="center" className="flex-1 td">
          <VYRO width={48} height={48} />
          <ThemedText.Text1Bold fontSize={24} ml="16px">
            <Trans>VYRO</Trans>
          </ThemedText.Text1Bold>
        </Box>
        <Box width="200px" className="text-right td">
          <ThemedText.Text1Medium fontSize={16}>
            {formatAmount2(
              VYROBalance?.plus(VYROStaked ? VYROStaked : 0),
              2,
              true
            )}
          </ThemedText.Text1Medium>
          <ThemedText.Text5 fontSize={12} mt="8px">
            $
            {formatAmount2(
              VYROBalance?.plus(VYROStaked ? VYROStaked : 0).times(
                VYROPrice ? VYROPrice : 1
              ),
              2,
              true
            )}
          </ThemedText.Text5>
        </Box>
        <Box width="200px" className="text-right td">
          <ThemedText.Text1Medium fontSize={16}>
            {formatAmount2(VYROBalance, 2, true)}
          </ThemedText.Text1Medium>
        </Box>
        <Box width="200px" className="text-right td">
          <ThemedText.Text1Medium fontSize={16}>
            {formatAmount2(VYROStaked, 2, true)}
          </ThemedText.Text1Medium>
        </Box>
        <Box display="flex" justifyContent="flex-end" className="flex-1 td">
          <Link component={NavLink} to={`/Earn?curr=${0}`}>
            <Box width="120px">
              <BuyBtn>Earn</BuyBtn>
            </Box>
          </Link>
          <Box width="120px" ml="16px">
            <ClaimBtn onClick={handlerBuy}>Buy / Sell</ClaimBtn>
          </Box>
        </Box>
      </Box>
      <Box display="flex" alignItems="center" className="assetItem">
        <Box display="flex" alignItems="center" className="flex-1 td">
          <EsVYRO width={48} height={48} />
          <ThemedText.Text1Bold fontSize={24} ml="16px">
            <Trans>esVYRO</Trans>
          </ThemedText.Text1Bold>
        </Box>
        <Box width="200px" className="text-right td">
          <ThemedText.Text1Medium fontSize={16}>
            {formatAmount2(
              esVYROBalance?.plus(esVYROStaked ? esVYROStaked : 0),
              2,
              true
            )}
          </ThemedText.Text1Medium>
          <ThemedText.Text5 fontSize={12} mt="8px">
            $
            {formatAmount2(
              esVYROBalance
                ?.plus(esVYROStaked ? esVYROStaked : 0)
                .times(VYROPrice ? VYROPrice : 1),
              2,
              true
            )}
          </ThemedText.Text5>
        </Box>
        <Box width="200px" className="text-right td">
          <ThemedText.Text1Medium fontSize={16}>
            {formatAmount2(esVYROBalance, 2, true)}
          </ThemedText.Text1Medium>
        </Box>
        <Box width="200px" className="text-right td">
          <ThemedText.Text1Medium fontSize={16}>
            {formatAmount2(esVYROStaked, 2, true)}
          </ThemedText.Text1Medium>
        </Box>
        <Box display="flex" justifyContent="flex-end" className="flex-1 td">
          <Link component={NavLink} to={`/Earn?curr=${0}`}>
            <Box width="120px">
              <BuyBtn>Earn</BuyBtn>
            </Box>
          </Link>
          <Box width="120px" ml="16px">
            <ClaimBtn disabled={true}>Buy / Sell</ClaimBtn>
          </Box>
        </Box>
      </Box>
      {/* {tokensArr?.length > 0 ? (
        tokensArr?.map((item, i) => (
          <Box display="flex" alignItems="center" className="assetItem" key={i}>
            <Box display="flex" alignItems="center" className="flex-1 td">
              <img src={item?.icon} width={48} height={48} />
              <ThemedText.Text1Bold fontSize={24} ml="16px">
                {item?.name}
              </ThemedText.Text1Bold>
            </Box>
            <Box width="200px" className="text-right td">
              <ThemedText.Text1Medium fontSize={16}>
                {formatAmount2(
                  item?.dlpBalance * 1 + item?.dlpBalanceStaked * 1,
                  2,
                  true
                )}
              </ThemedText.Text1Medium>
              <ThemedText.Text5 fontSize={12} mt="8px">
                $
                {formatAmount2(
                  (item?.dlpBalance * 1 + item?.dlpBalanceStaked * 1) *
                    item?.price,
                  2,
                  true
                )}
              </ThemedText.Text5>
            </Box>
            <Box width="200px" className="text-right td">
              <ThemedText.Text1Medium fontSize={16}>
                {formatAmount2(item?.dlpBalance, 2, true)}
              </ThemedText.Text1Medium>
            </Box>
            <Box width="200px" className="text-right td">
              <ThemedText.Text1Medium fontSize={16}>
                {formatAmount2(item?.dlpBalanceStaked, 2, true)}
              </ThemedText.Text1Medium>
            </Box>
            <Box display="flex" justifyContent="flex-end" className="flex-1 td">
              <Link component={NavLink} to={`/Earn?curr=${1}`}>
                <Box width="120px">
                  <BuyBtn>Earn</BuyBtn>
                </Box>
              </Link>
              <Box width="120px" ml="16px">
                <Link component={NavLink} to={`/Earn?curr=${1}`}>
                  <ClaimBtn disabled={true}>Buy / Sell</ClaimBtn>
                </Link>
              </Box>
            </Box>
          </Box>
        ))
      ) : (
        <div className="flex-1">
          <Skeleton width="100%" height={60} style={{ borderRadius: "10px" }} />
        </div>
      )} */}
      <Box display="flex" alignItems="center" className="assetItem">
        <Box display="flex" alignItems="center" className="flex-1 td">
          <USDT width={48} height={48} />
          <ThemedText.Text1Bold fontSize={24} ml="16px">
            <Trans>USDT</Trans>
          </ThemedText.Text1Bold>
        </Box>
        <Box width="200px" className="text-right td">
          <ThemedText.Text1Medium fontSize={16}>
            {formatAmount2(usdcBalance, 2, true)}
          </ThemedText.Text1Medium>
          <ThemedText.Text5 fontSize={12} mt="8px">
            ${formatAmount2(usdcBalance, 2, true)}
          </ThemedText.Text5>
        </Box>
        <Box width="200px" className="text-right td">
          <ThemedText.Text1Medium fontSize={16}>
            {formatAmount2(usdcBalance, 2, true)}
          </ThemedText.Text1Medium>
        </Box>
        <Box width="200px" className="text-right td">
          <ThemedText.Text1Medium fontSize={16}>
            {formatAmount2(0, 2, true)}
          </ThemedText.Text1Medium>
        </Box>
        <Box display="flex" justifyContent="flex-end" className="flex-1 td">
          <></>
        </Box>
      </Box>
    </AssetBox>
  );
}
